<div class="p-fluid p-formgrid p-grid">
  <div class="p-col-12 p-sm-12  p-md-12 p-lg-3">
    <p-card header="Filtros" (keyup)="ds.onEnterPesquisar($event)">
      <div class="p-grid">
        <m-restricao-string label="Tabela"  [restricao]="ds.restricoes.atributo('tabela')"></m-restricao-string>
      </div>
      <p-footer>
        <div class="p-fluid p-grid">
          <div class="p-field p-col">
            <button pButton label="Pesquisar" (click)="ds.pesquisar()"></button>
          </div>
          <div class="p-field p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="ds.limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>
  <div class="p-col-12 p-sm-12  p-md-12 p-lg-9">
    <p-card header="Lista de Particionamentos">
      <div class="responsividade">
        <p-table
          *ngIf="ds !== undefined"
          [multiSortMeta]="ds.ordenacoes"
          [value]="ds.entidades" dataKey="tabela"
          [totalRecords]="ds.total"
          (onLazyLoad)="ds.carregar($event)"
          [lazy]="true"
          [(rows)]="ds.registros"
          [paginator]="true"
          responsive="true"
          sortField="tabela"
          sortMode="multiple">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 3rem"></th>
              <th pSortableColumn="tabela" style="width:16rem">Tabela <p-sortIcon field="tabela"></p-sortIcon></th>
              <th style="width: 6rem">Intervalo</th>
              <th style="width:4rem">Atual</th>
              <th style="width:5rem">Última </th>
              <th style="width:7rem">Posteriores</th>
              <th class="break p-text-center" style="width:8rem">Último Gerenciamento</th>
              <th style="width:6rem">Ações</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body"  let-entidade let-expanded="expanded">
            <tr>
              <td>
                <button type="button" pButton pRipple [pRowToggler]="entidade" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
              </td>
              <td class="break">{{entidade.tabela}} -  {{entidade.colunaControle}}</td>
              <td class="p-text-center">{{entidade.intervalo}}</td>
              <td class="p-text-center">{{entidade.particaoAtual}} </td>
              <td class="p-text-center">{{entidade.ultimaParticao}} </td>
              <td class="p-text-center">{{entidade.quantidadeParticoesPosteriores}} </td>
              <td class="p-text-center">
                {{entidade.ultimoGerenciamentoData | date:'dd/MM/yyyy HH:mm:ss'}} -
                <span [ngClass]="entidade.ultimoGerenciamentoSituacao === 'SUCESSO' ? 'badge badge-success' : 'badge badge-danger'">
                  {{ entidade.ultimoGerenciamentoSituacao === 'SUCESSO' ? 'Sucesso' : 'Erro' }}
                </span>
              </td>
              <td class="p-text-center"><p-button type="button" icon="pi pi-sync" title="Gerenciar particionamentos linha" (click)="gerenciarParticionamentoDaTabela(entidade)"></p-button></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-entidades>
            <tr>
              <td colspan="9">
                <div class="p-p-3">
                  <p-table [value]="extrairInformacoesParticoes(entidades.particoes)"
                    dataKey="tabela"
                    sortMode="multiple"
                    sortField="particoes">
                    <ng-template pTemplate="header">
                      <tr>
                        <th pSortableColumn="tabela" style="width:22rem">Partições <p-sortIcon field="tabela"></p-sortIcon></th>
                        <th pSortableColumn="de" class="p-text-center" style="width:10rem">De <p-sortIcon field="de"></p-sortIcon></th>
                        <th pSortableColumn="ate" class="p-text-center" style="width:10rem">Até <p-sortIcon field="ate"></p-sortIcon></th>
                        <th pSortableColumn="linhas" class="p-text-center" style="width:10rem">Linhas <p-sortIcon field="linhas"></p-sortIcon></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-entidade>
                      <tr>
                        <td class="p-text-break">
                         <p>{{entidade.tabela}}</p>
                        </td>
                        <td>
                          <p>{{entidade.de}}</p>
                        </td>
                        <td>
                          <p>{{entidade.ate}}</p>
                        </td>
                        <td>
                          <p>{{entidade.quantidadeLinhas}}</p>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="p-fluid p-formgrid p-grid col-md-12 p-t-5">
        <div class="p-field p-col-6">
          <button pButton (click)="gerenciarParticionamentos()" class="p-primary" label="Gerenciar particionamentos"></button>
        </div>
        <div class="p-field p-col-6 p-text-right">
          Quantidade de registros: <span class="p-text-bold">{{ds.total}}</span>
        </div>
      </div>
    </p-card>
  </div>
</div>
